const roleConfig = {
  name: 'Role',
  endpoint: '/internal_admin/admin_kit/roles',
  modelKey: 'rbac_role',

  columns: [
    { name: 'name', title: 'Name', type: 'link' },
    { name: 'description', title: 'Description' },
    { name: 'account_name', title: 'Account' },
    { name: 'public', title: 'Public', type: 'boolean' },
    { name: 'created_at', title: 'Created' },
  ],

  filters: [
    { name: 'q[name_cont]', label: 'Name' },
    { name: 'q[description_cont]', label: 'Description' },
    {
      name: 'q[public_eq]',
      label: 'Public',
      options: () => [
        { id: 'true', label: 'Yes', value: 'true' },
        { id: 'false', label: 'No', value: 'false' },
      ],
    },
  ],

  attributes: [
    { name: 'id', label: 'ID' },
    { name: 'name', label: 'Name' },
    { name: 'description', label: 'Description' },
    { name: 'account_name', label: 'Account' },
    { name: 'public', label: 'Public', type: 'boolean' },
    { name: 'created_by_name', label: 'Created By' },
    { name: 'created_at', label: 'Created At' },
    { name: 'updated_at', label: 'Updated At' },
  ],

  panels: [
    {
      title: 'Permissions',
      endpoint: (record) =>
        `/internal_admin/admin_kit/roles/${record.id}/permissions`,
      columns: [
        { name: 'name', title: 'Name' },
        { name: 'description', title: 'Description' },
      ],
      add: {
        endpoint: (record) =>
          `/internal_admin/admin_kit/roles/${record.id}/add_permission`,
        paramKey: 'role_permission',
        field: {
          name: 'permission_id',
          label: 'Permission',
          type: 'typeahead',
          searchEndpoint: '/internal_admin/admin_kit/roles/permission_search',
        },
      },
      remove: {
        endpoint: (record, row) =>
          `/internal_admin/admin_kit/roles/${record.id}/remove_permission/${row.id}`,
      },
    },
  ],

  form: {
    fields: [
      { name: 'name', label: 'Name', type: 'text', required: true },
      {
        name: 'description',
        label: 'Description',
        type: 'text',
        required: true,
      },
      {
        name: 'account_id',
        label: 'Account',
        type: 'typeahead',
        searchEndpoint: '/internal_admin/admin_kit/roles/dealer_search',
        displayField: 'account_label',
        helpMessage: 'Search by dealer name or Decisiv ID (min 2 characters)',
      },
      {
        name: 'public',
        label: 'Public',
        type: 'checkbox',
        defaultValue: false,
      },
    ],
  },
};

export default roleConfig;
